/*
 * SS Reviews Carousel — Phase 1 + Phase 2
 * Vanilla JS, no libraries. Builds the cards from a first-party theme asset
 * (data-src) and appends a quiet "See all reviews" end card as the last scroll
 * item. That card opens Judge.me's existing Floating Reviews Tab popup by
 * triggering its (visually hidden) tab handle — no custom modal, no extra
 * requests added on load.
 */
(function () {
  'use strict';

  // Inline SVG path data (24x24 viewBox) — keep in sync with the section's Liquid.
  var STAR_PATH =
    'M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z';
  var VERIFIED_PATH =
    'M23 12l-2.44-2.79.34-3.69-3.61-.82-1.89-3.2L12 2.96 8.6 1.5 6.71 4.69 3.1 5.5l.34 3.7L1 12l2.44 2.79-.34 3.7 3.61.82 1.89 3.2L12 21.04l3.4 1.46 1.89-3.2 3.61-.82-.34-3.69L23 12zm-12.91 4.72l-3.8-3.81 1.48-1.48 2.32 2.33 5.85-5.87 1.48 1.48-7.33 7.35z';

  function clampRating(value) {
    var n = Math.round(Number(value) || 0);
    if (n < 0) return 0;
    if (n > 5) return 5;
    return n;
  }

  function starSvg(on) {
    var cls = 'ss-reviews__star ' + (on ? 'ss-reviews__star--on' : 'ss-reviews__star--off');
    return (
      '<svg class="' + cls + '" viewBox="0 0 24 24" width="16" height="16" ' +
      'aria-hidden="true" focusable="false"><path d="' + STAR_PATH + '"/></svg>'
    );
  }

  function starsRow(rating) {
    var filled = clampRating(rating);
    var html = '';
    for (var i = 1; i <= 5; i++) {
      html += starSvg(i <= filled);
    }
    return html;
  }

  function buildCard(review) {
    var rating = clampRating(review.rating);
    var verified = review.verified === true;

    var li = document.createElement('li');
    li.className = 'ss-reviews__card-item';

    var verifiedHtml = verified
      ? '<span class="ss-reviews__verified">' +
        '<svg class="ss-reviews__verified-icon" viewBox="0 0 24 24" width="16" height="16" ' +
        'aria-hidden="true" focusable="false"><path d="' + VERIFIED_PATH + '"/></svg>' +
        '<span class="ss-reviews__vh">Verified purchase</span>' +
        '</span>'
      : '';

    li.innerHTML =
      '<article class="ss-reviews__card">' +
      '<div class="ss-reviews__stars-row" role="img" aria-label="' + rating + ' out of 5 stars">' +
      starsRow(rating) +
      '</div>' +
      '<p class="ss-reviews__body"></p>' +
      '<footer class="ss-reviews__foot">' +
      '<span class="ss-reviews__name"></span>' +
      verifiedHtml +
      '</footer>' +
      '</article>';

    // Set untrusted text via textContent (never innerHTML) to avoid markup injection.
    li.querySelector('.ss-reviews__body').textContent = review.body || '';
    li.querySelector('.ss-reviews__name').textContent = review.name || '';

    return li;
  }

  function hide(root) {
    root.style.display = 'none';
  }

  function wireArrows(root, track) {
    var prev = root.querySelector('[data-ss-prev]');
    var next = root.querySelector('[data-ss-next]');
    if (!prev && !next) return;

    function step(direction) {
      var card = track.querySelector('.ss-reviews__card-item');
      var styles = getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      var amount = card ? card.getBoundingClientRect().width + gap : track.clientWidth;
      track.scrollBy({ left: direction * amount, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
  }

  function openJudgemeTab() {
    // Phase 2: open Judge.me's floating Reviews Tab popup by triggering its
    // (visually hidden) tab handle. Try known variants; fail silently otherwise.
    var tab =
      document.querySelector('.jdgm-revs-tab-btn') ||
      document.querySelector('.jdgm-revs-tab__btn') ||
      document.querySelector('[class*="jdgm-revs-tab"][role="button"]');
    if (tab) tab.click();
  }

  function buildEndCard(label) {
    var li = document.createElement('li');
    li.className = 'ss-reviews__card-item ss-reviews__card-item--more';
    li.innerHTML =
      '<button type="button" class="ss-reviews__more-card" data-ss-see-more>' +
      '<span class="ss-reviews__more-icon" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" ' +
      'stroke-width="2" stroke-linecap="round" stroke-linejoin="round" focusable="false">' +
      '<path d="M5 12h14M13 6l6 6-6 6"/></svg>' +
      '</span>' +
      '<span class="ss-reviews__more-label"></span>' +
      '</button>';

    li.querySelector('.ss-reviews__more-label').textContent = label;
    li.querySelector('[data-ss-see-more]').addEventListener('click', openJudgemeTab);

    return li;
  }

  function render(root, track, reviews) {
    var frag = document.createDocumentFragment();
    for (var i = 0; i < reviews.length; i++) {
      frag.appendChild(buildCard(reviews[i]));
    }

    // Append the quiet "See all reviews" card as the LAST item in the track.
    if (root.getAttribute('data-show-see-more') === 'true') {
      var label = root.getAttribute('data-see-more-label') || 'See all reviews';
      frag.appendChild(buildEndCard(label));
    }

    track.innerHTML = '';
    track.appendChild(frag);
    wireArrows(root, track);
  }

  function pickReviews(data, locale) {
    if (!data) return [];
    // Use the locale's curated list when it exists AND has entries; otherwise
    // fall back to "default". (An empty locale array falls back too.)
    var localized = data[locale];
    if (localized && localized.length) return localized;
    var fallback = data['default'];
    return fallback && fallback.length ? fallback : [];
  }

  function initOne(root) {
    if (root.getAttribute('data-ss-init') === 'true') return;
    root.setAttribute('data-ss-init', 'true');

    var src = root.getAttribute('data-src');
    var track = root.querySelector('[data-ss-track]');
    if (!src || !track) {
      hide(root);
      return;
    }

    // de-de -> de, EN -> en
    var rawLocale = (root.getAttribute('data-locale') || '').toLowerCase();
    var locale = rawLocale.split('-')[0];

    fetch(src, { credentials: 'omit' })
      .then(function (res) {
        if (!res.ok) throw new Error('Request failed: ' + res.status);
        return res.json();
      })
      .then(function (data) {
        var reviews = pickReviews(data, locale);
        if (!reviews.length) {
          hide(root); // Never render an empty carousel.
          return;
        }
        render(root, track, reviews);
      })
      .catch(function () {
        hide(root); // Fetch/parse failed — hide gracefully.
      });
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-ss-reviews]');
    for (var i = 0; i < roots.length; i++) {
      initOne(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-initialize when the section is added/edited in the Shopify theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-ss-reviews]');
    if (root) initOne(root);
  });
})();
